import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import Customers from './Customers/Customers';
import Transfers from './Transfers/Transfers';
import Alerts from './Alerts/Alerts';

const ComplianceDashboardOverview = () => {
  const { t } = useTranslation();

  const tabs: TabsProps['items'] = [
    {
      key: 'сustomers',
      label: t('translation.customers'),
      children: <Customers />,
    },
    {
      key: 'transfers',
      label: t('translation.transfers'),
      children: <Transfers />,
    },
    {
      key: 'alerts',
      label: t('translation.alerts'),
      children: <Alerts />,
    },
  ];

  return <Tabs defaultActiveKey="1" items={tabs} destroyOnHidden />;
};

export default ComplianceDashboardOverview;
